import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import {
  getAssessmentTypeDropdown,
  getOptionTypeDropdown,
  getTrainingDropdown,
  saveAssessment,
} from "../../services/TrainingAssessment/TrainingAssessmentServices";
import { CloseModalIcon } from "../../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../../common/components/divider/CommonDivider";
import InputField from "../../../../../common/components/FormFields/InputField";
import DropdownField from "../../../../../common/components/FormFields/DropdownField";
import CommonTransactionTable from "../../../../../common/components/CommonTable/CommonTransactionTable";
import CheckBoxField from "../../../../../common/components/FormFields/CheckBoxField";
import ControlledCheckBoxField from "../../../../../common/components/FormFields/ControlledCheckBoxField";
import { DeleteIcon, EditIcon } from "../../../../../assets/CommonAssets";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import {
  errorAlert,
  successAlert,
} from "../../../../../common/components/Toasts/CustomToasts";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "95vh",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  p: 2,
};
const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];
const answerTypeOptions = [
  { label: "Free Text", value: "TEXT" },
  { label: "Radio", value: "RADIO" },
  { label: "Checkbox", value: "CHECKBOX" },
];

const assessmentTypeOptions = [
  { label: "Pre Assessment", value: "PRE" },
  { label: "Post Assessment", value: "POST" },
];

const schema = yup?.object().shape({
  // training: yup?.object().required("Training is required"),
  // assessmentType: yup?.object().required("Assessment type is required"),
  // question: yup?.string().trim().required("Question is required"),
  // answerType: yup?.object().required("Answer type is required"),
  assessmentName: yup?.string().trim().required("assessmentName is required"),
});

const defaultValues = {
  training: null,
  assessmentType: null,
  question: "",
  answerType: null,
  assessmentName: "",
  // isMulti:false
};

const TrainingAssessmentTestModal = ({
  TrainingAssessmentTestModalOpen,
  setTrainingAssessmentTestModalOpen,
  selectedRow,
  setSelectedRow,
  populateTable,
  setOpenBackdrop,
  openBackDrop,
}) => {
  const [options, setOptions] = useState([{ label: "", isCorrect: false }]);
  const [questions, setQuestions] = useState([]);
  const [selectedTrainings, setSelectedTrainings] = useState([]);
  const [trainingDrodown, setTrainingDropdown] = useState([]);
  const [AssessmentTypeDropdown, setAssessmentypeDropdown] = useState([]);
  const [optionTypeDropdown, setOptiontypeDropdown] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const training = watch("training");
  const handleEditQuestion = (q, index) => {
    setEditIndex(index);
    console.log(q, "question");
    setValue("question", q?.question);
    setValue("isMulti", q?.["isMulti"]);
    setValue("answerType", {
      id: q?.optionType?.id,
      label: q?.optionType?.label,
      value: q?.optionType?.id,
    });

    // setValue("isMulti", q?.isMulti || false);

    if (q?.optionType?.id !== 1) {
      const opts = q?.optionRequestDto.map((opt, i) => {
        setValue(`Option${i}`, opt?.option);
        return {
          label: opt?.option,
          isCorrect: opt?.is_answer,
        };
      });

      setOptions(opts);
    } else {
      setOptions([{ label: "", isCorrect: false }]);
    }
  };
  const answerType = watch("answerType");

  useEffect(() => {
    if (answerType?.value === "TEXT") {
      setOptions([{ label: "", isCorrect: false }]);
    }
  }, [answerType]);

  const areAllOptionsFilled = () => {
    for (let i = 0; i < options?.length; i++) {
      const fieldValue = watch(`Option${i}`);
      if (!fieldValue || fieldValue?.trim() === "") {
        return false;
      }
    }
    return true;
  };

  const hasCorrectAnswer = () => {
    return options?.some((opt) => opt?.isCorrect === true);
  };

  const addOption = () => {
    if (!areAllOptionsFilled()) {
      errorAlert("Please fill all existing options before adding a new one");
      return;
    }

    setOptions([...options, { label: "", isCorrect: false }]);
  };

  ///this is for multiCheck
  const updateOption = (index, key, value) => {
    const copy = [...options];
    const isMulti = watch("isMulti");

    if (key === "isCorrect") {
      if (!isMulti) {
        // Radio behavior - sirf ek hi correct
        copy?.forEach((opt, i) => {
          opt.isCorrect = i === index ? value : false;
        });
      } else {
        // Multi behavior - multiple correct allowed
        copy[index][key] = value;
      }
    } else {
      copy[index][key] = value;
    }

    setOptions(copy);
    if (key === "label") {
      setValue(`Option${index}`, value);
    }
  };
  // const updateOption = (index, key, value) => {
  //   const copy = [...options];

  //   if (key === "isCorrect" && value && answerType?.value === "RADIO") {
  //     copy?.forEach((opt, i) => {
  //       opt.isCorrect = i === index;
  //     });
  //   } else {
  //     copy[index][key] = value;
  //   }

  //   setOptions(copy);
  //   if (key === "label") {
  //     setValue(`Option${index}`, value);
  //   }
  // };

  const removeOption = (index) => {
    if (options?.length === 1) {
      errorAlert("At least one option is required");
      return;
    }
    setOptions(options?.filter((_, i) => i !== index));
  };

 const addQuestion = () => {
    const questionText = watch("question");
    const answerTypeObj = watch("answerType");

    if (!questionText || questionText?.trim() === "") {
      errorAlert("Please fill question first");
      return;
    }

    if (!answerTypeObj) {
      errorAlert("Please select option type");
      return;
    }

    const optionTypeId = answerTypeObj?.id;

    if (optionTypeId !== 1) {
      if (!areAllOptionsFilled()) {
        errorAlert("Please fill all options");
        return;
      }

      if (options?.length < 2) {
        errorAlert("Please add at least 2 options");
        return;
      }

      if (!hasCorrectAnswer()) {
        errorAlert("Please mark at least one correct option");
        return;
      }
    }

    const syncedOptions =
      optionTypeId === 1
        ? []
        : options?.map((opt, index) => ({
            option: watch(`Option${index}`),
            is_answer: opt?.isCorrect,
          }));

    const newQuestion = {
      question: questionText,
      optionType: { id: optionTypeId, label: answerTypeObj?.label },
      optionRequestDto: syncedOptions,
      isMulti: watch("isMulti"),
    };

    if (editIndex !== null) {
      const updated = [...questions];
      updated[editIndex] = newQuestion;
      setQuestions(updated);
      setEditIndex(null);
    } else {
      setQuestions((prev) => [...prev, newQuestion]);
    }
    //clear all fields
    options?.forEach((_, index) => {
      setValue(`Option${index}`, "");
      setValue(`isCorrect${index}`, false);
    });
    // reset form
    setValue("isMulti", false);
    setValue("question", "");
    setValue("answerType", null);
    setOptions([{ label: "", isCorrect: false }]);
  };
  console.log(selectedRow, "sss");
  useEffect(() => {
    if (!selectedRow || selectedRow?.length === 0) return;

    const data = selectedRow[0];

    setValue("assessmentName", data?.assessment || "");

    setValue("assessmentType", {
      id: data?.assessment_type?.id,
      label: data?.assessment_type?.assessment_type,
      value: data?.assessment_type?.id,
    });

    if (Array.isArray(data?.trainings)) {
      const patchedTrainings = data?.trainings?.map((obj) => ({
        id: obj?.id,
        name: obj?.name,
      }));

      setSelectedTrainings(patchedTrainings);
    }

    if (Array.isArray(data?.assessment_details)) {
      const patchedQuestions = data?.assessment_details?.map((q) => ({
        question: q?.question,
        optionType: {
          id: q?.option_type_id,
          label: q?.option_type?.option_type,
        },
        optionRequestDto:
          q?.option?.map((opt) => ({
            option: opt?.option,
            is_answer: opt?.is_answer,
          })) || [],
        isMulti: q?.isMulti,
      }));

      setQuestions(patchedQuestions);
    }
  }, [selectedRow]);

  const removeQuestion = (index) => {
    setQuestions(questions?.filter((_, idx) => idx !== index));
  };

  const onSubmit = (formData) => {
    if (questions?.length === 0) {
      errorAlert("Please add at least one question before saving");
      return;
    }

    let tempArr = selectedTrainings?.map((obj) => {
      return obj?.value || obj?.id;
    });

    console.log(selectedRow, "jjjj");
    const payload = {
      id: selectedRow?.length > 0 ? selectedRow[0]?.id : null,
      assessment: formData?.assessmentName,
      assessmentType: {
        id: formData?.assessmentType?.id || formData?.assessmentType?.value,
      },
      trainings: [],
      assessmentDetailRequestDtos: questions,
      active: true,
    };

    console.log("ASSESSMENT PAYLOAD", payload);

    // Here you would typically make an API call to save the assessment
    // Example: await saveAssessment(payload);
    setFinalData(payload);
    setOpenPostModal(true);
  };
  const handleSaveRecord = () => {
    setOpenPostModal(false);
    // setTrainingModalOpen(false);
    setOpenBackdrop(true);
    setOpenPostModal(false);
    saveAssessment(finalData)
      .then((response) => response?.data)
      .then((res) => {
        if (res?.statusCode === 201 || res?.statusCode === 200) {
          setTrainingAssessmentTestModalOpen(false);
          populateTable();
          setSelectedRow(null);
          successAlert(res?.message);
          setOpenBackdrop(false);
          reset(defaultValues);
          setQuestions([]);
          setOptions([{ label: "", isCorrect: false }]);
          setSelectedTrainings([]);
        }
      })
      .catch((error) => {
        errorAlert(error?.message);
        setOpenBackdrop(false);
      });
  };
  const handleClose = () => {
    reset(defaultValues);

    setQuestions([]);
    setOptions([{ label: "", isCorrect: false }]);
    setSelectedTrainings([]);
    setSelectedRow(null);
    setEditIndex(null);
    setTrainingAssessmentTestModalOpen(false);
  };

  const handleReset = () => {
    reset(defaultValues);
    setSelectedTrainings([]);
    setQuestions([]);
    setOptions([{ label: "", isCorrect: false }]);
    setSelectedRow(null);
    setEditIndex(null);
  };
  // useEffect(() => {
  //   if (!training) return;

  //   setSelectedTrainings((prev) => {
  //     const exists = prev?.some(
  //       (t) => t?.id === training?.value || t?.name === training?.label,
  //     );

  //     if (exists) return prev;

  //     return [
  //       ...prev,
  //       {
  //         id: training?.value || training?.id,
  //         name: training?.label,
  //       },
  //     ];
  //   });
  //   setValue("training", null);

  //   console.log(selectedTrainings, "selectedTrainings");
  // }, [training]);
  const handleDeleteTraining = (row) => {
    setSelectedTrainings((prev) =>
      prev?.filter((training) => training?.id !== row?.id),
    );
  };
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-0 items-center">
        {userActions?.map((actions, i) => (
          <>
            {actions?.isAction === true ? (
              <div className="flex gap-2 cursor-pointer">
                {actions?.permission === "Delete" ? (
                  <DeleteIcon
                    sx={{ color: "#D11A2A" }}
                    type={"button"}
                    onClick={() => handleDeleteTraining(row)}
                    // onClick={() => {
                    //   setOpenDeleteModal(true);
                    //   setSelectedRow(row);
                    // }}
                  />
                ) : null}
              </div>
            ) : null}
          </>
        ))}
      </div>
    );
  };

  // useEffect(() => {
  //   getTrainingDropdown()
  //     .then((response) => response?.data)
  //     .then((res) => {
  //       if (res?.statusCode === 200) {
  //         setTrainingDropdown(res?.result);
  //       }
  //     })
  //     .catch((error) => errorAlert(error?.message));
  // }, []);
  useEffect(() => {
    getAssessmentTypeDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res?.statusCode === 200) {
          setAssessmentypeDropdown(res?.result);
        }
      })
      .catch((error) => errorAlert(error?.message));
  }, []);
  useEffect(() => {
    getOptionTypeDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res?.statusCode === 200) {
          setOptiontypeDropdown(res?.result);
        }
      })
      .catch((error) => errorAlert(error?.message));
  }, []);

  return (
    <Modal
      open={TrainingAssessmentTestModalOpen}
      onClose={handleClose}
      aria-labelledby="assessment-modal-title"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={ModalStyle} className="w-[90%] rounded-lg overflow-y-auto">
          <div className="flex justify-between items-center">
            <h1 id="assessment-modal-title" className="font-semibold text-lg">
              Add New Assessment
            </h1>
            <div onClick={handleClose}>
              <CloseModalIcon className="cursor-pointer" />
            </div>
          </div>

          <CommonDivider color="E0E0E0" />

          <div className="grid grid-cols-12 gap-4 mt-3">
            <div className="col-span-7 space-y-4 overflow-y-auto">
              <div className="grid grid-cols-2 gap-2 my-2  rounded-lg">
                {/* <DropdownField
                  dataArray={trainingList}
                  control={control}
                  name="training"
                  placeholder="Select Training"
                  error={errors?.training}
                  isSearchable
                  searchIcon={true}
                  isClearable={true}
                /> */}
                <InputField
                  className="border rounded px-2 py-1 w-full"
                  label={`Assessment Name*`}
                  name={`assessmentName`}
                  control={control}
                  error={errors?.assessmentName}
                />
                <DropdownField
                  dataArray={AssessmentTypeDropdown}
                  control={control}
                  name="assessmentType"
                  placeholder="Assessment Type*"
                  error={errors?.assessmentType}
                  isClearable={true}
                  isSearchable={true}
                />
              </div>
              {/* <div className=" border-t border-gray-200 rounded-lg">
                <div className="grid grid-cols-2 mt-3">
                  <DropdownField
                    dataArray={trainingDrodown}
                    control={control}
                    name="training"
                    placeholder="Link With Training"
                    error={errors?.training}
                    isSearchable
                    searchIcon={true}
                    isClearable={true}
                  />
                </div>
                <div className="md:w-[60%]">
                  {selectedTrainings?.length > 0 ? (
                    <CommonTransactionTable
                      // page={page}
                      // rowsPerPage={rowsPerPage}
                      // setPage={setPage}
                      populateTable={populateTable}
                      // count={count}
                      highlightRow={false}
                      dataResult={selectedTrainings}
                      // renderActions={renderActions}
                      // renderInput={renderInput}
                      editableColumns={"Status"}
                      tableClass="capitalize max-h-[141px] overflow-scroll"
                      removeHeaders={["id", "value"]}
                      renderActions={renderActions}
                    />
                  ) : (
                    <>
                      {
                        <div className="flex justify-center">
                          <h3 className="flex justify-center my-6 font-bold text-gray-600">
                            No Records Found...
                          </h3>
                        </div>
                      }
                    </>
                  )}
                </div>
              </div> */}
              <div className="my-2 p-4 border border-gray-300 rounded-lg shadow-md min-h-[50vh]">
                <h2 className="font-semibold mb-2">Assessment Question</h2>
                <div className="grid grid-cols-[65%_35%] gap-2 my-2">
                  <InputField
                    label="Question*"
                    name="question"
                    control={control}
                    error={errors?.question}
                  />

                  <DropdownField
                    dataArray={optionTypeDropdown}
                    control={control}
                    name="answerType"
                    placeholder="Options Type"
                    error={errors?.answerType}
                    isClearable={true}
                    isSearchable={true}
                  />
                  <CheckBoxField
                    control={control}
                    name="isMulti"
                    defaultValue={false}
                    label="Is Multi"
                  />
                </div>

                {answerType?.value && answerType?.value !== 1 && (
                  ///this is for multiCheck

                  <div className="space-y-2 gap-2">
                    {options?.map((opt, index) => (
                      <div key={index} className="flex items-center gap-4">
                        <InputField
                          className="border rounded px-2 py-1 w-full"
                          label={`Option ${index + 1}`}
                          name={`Option${index}`}
                          control={control}
                          onChange={(e) =>
                            updateOption(index, "label", e?.target.value)
                          }
                        />
                        <Tooltip title="Is Answer">
                          <ControlledCheckBoxField
                            name={`isCorrect${index}`}
                            label="Correct"
                            control={control}
                            value={opt?.isCorrect}
                            onChange={(val) =>
                              updateOption(index, "isCorrect", val)
                            }
                          />
                        </Tooltip>
                        <div>
                          {options?.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeOption(index)}
                            >
                              <DeleteIcon className="cursor-pointer text-red-500 hover:text-red-700" />
                            </button>
                          )}
                        </div>
                      </div>
                    ))}

                    <div className="flex ">
                      <CommonButton
                        type="button"
                        label="+ Add Option"
                        onClick={addOption}
                        className="px-3 border border-customBlue text-customBlue "
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="flex justify-end">
                <CommonButton
                  type="button"
                  label={
                    editIndex !== null ? "Update Question" : "+ Add Question"
                  }
                  onClick={addQuestion}
                  disabled={editIndex !== null && !watch("question")}
                  className="bg-customBlue text-white"
                />
              </div>
            </div>
            <div className="col-span-5 space-y-3 my-2 h-[75vh] overflow-y-scroll p-4 border border-gray-300 rounded-lg bg-gray-50">
              <h2 className="font-semibold sticky top-0 bg-gray-50 pb-2">
                Questions Preview : {questions?.length}
              </h2>

              {questions?.length === 0 ? (
                <div className="text-center text-gray-500 py-8">
                  No questions added
                </div>
              ) : (
                questions?.map((q, i) => (
                  <div
                    key={i}
                    className="border rounded p-3 bg-white shadow-sm"
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="font-medium">Question {i + 1}</h3>
                      {q?.isMulti && (
                        <span className="text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full font-medium">
                          Multi Select
                        </span>
                      )}

                      <div className="flex gap-2">
                        <button
                          type="button"
                          onClick={() => handleEditQuestion(q, i)}
                        >
                          <EditIcon className="cursor-pointer text-blue-500 hover:text-blue-700" />
                        </button>
                        <button type="button" onClick={() => removeQuestion(i)}>
                          <DeleteIcon className="cursor-pointer text-red-500 hover:text-red-700" />
                        </button>
                      </div>
                    </div>

                    <p className="text-sm mt-1 text-gray-700">{q?.question}</p>

                    {q?.answerType === 1 && (
                      <input
                        disabled
                        placeholder="Free text answer..."
                        className="border w-full mt-2 px-2 py-1 bg-gray-100 rounded"
                      />
                    )}
                    {q?.optionType?.id !== 1 && (
                      <div className="mt-2 space-y-1 ">
                        {q?.optionRequestDto?.map((o, idx) => (
                          <div
                            key={idx}
                            className={`flex gap-2 items-center p-1 rounded ${
                              o?.is_answer ? "bg-green-50" : ""
                            }`}
                          >
                            {" "}
                            <input
                              type={
                                q?.optionType?.id === 2 ? "radio" : "checkbox"
                              }
                              disabled
                              readOnly
                              checked={o?.is_answer}
                            />
                            <span>{o?.option}</span>
                            {o?.is_answer && (
                              <span className="text-xs text-green-600 ml-auto">
                                ✓ Correct
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-2 mt-4">
            <CommonButton
              type="button"
              label="Reset"
              onClick={handleReset}
              className="resetButton px-6 py-2 border border-red-500 text-red-500 hover:bg-red-50"
            />

            <CommonButton
              type="submit"
              label="Save"
              className="bg-green-700 text-white hover:bg-green-800 px-8"
            />
          </div>
          <ConfirmationModal
            confirmationOpen={openPostModal}
            confirmationHandleClose={() => setOpenPostModal(false)}
            confirmationLabel="Confirmation"
            confirmationMsg={`Are you sure you want to Save this record?`}
            confirmationSubmitFunc={() => {
              handleSaveRecord();
            }}
            confirmationButtonMsg="Save"
          />
        </Box>
      </form>
    </Modal>
  );
};

export default TrainingAssessmentTestModal;
